import { $api } from "../generated/client";

export function useCurrentUser() {
  return $api.useQuery("get", "/users/me");
}
